export default {"src":"/_next/static/media/ga-logo-with-background.32b07d95.svg","height":65,"width":65,"blurWidth":0,"blurHeight":0};